export const generateProductTitle = (
  productType: {
    title: string;
  },
  manufacturer: {
    title: string;
  },
  properties: {
    isVariant: boolean;
    descriptor: {
      enums: {
        key: string;
        title: string;
      }[];
      title: string;
    };
    key: string;
    value: string;
  }[]
): string => {
  const variants: string[] | undefined = properties
    .filter(property => property.isVariant)
    .map<string>(property => {
      const enums = property.descriptor?.enums ?? [];
      const propertyValue = property?.value.toString();
      const propertyKey = property?.key;
      let title = propertyKey ?? '';

      if (propertyValue) {
        title = enums.find(penum => -1 !== propertyValue.indexOf(penum.key))?.title ?? propertyKey;
      }

      return title;
    });

  return `${manufacturer.title} ${productType.title} ${0 < variants.length ? ` - ${variants.join(' | ')}` : ''}`;};
